import React from 'react';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { toggle } from '../nav/navSlice';
import styles from './top-bar.module.css';
import { Bars3Icon } from '@heroicons/react/24/solid';
import { clearToken, selectTokenPayload } from '../login/authSlice';
import { ChevronDownIcon } from '@heroicons/react/24/solid';
import { ContextMenu } from 'shared-components';
import { useNavigate } from 'react-router-dom';
import { Routes as RouteList } from '../../app/routes';
import Avvvatars from 'avvvatars-react';
import { SearchTrigger } from '../command-palette/search-trigger';

interface TopBarProps {
  onSearchClick?: () => void;
}

export const TopBar = ({ onSearchClick }: TopBarProps) => {
  const dispatch = useAppDispatch();
  const nav = useNavigate();
  const tokenData = useAppSelector(selectTokenPayload);
  return (
    <div className={styles.topBar}>
      <div
        className={styles.topBar__menu}
        onClick={() => {
          dispatch(toggle());
        }}
      >
        <Bars3Icon color={'black'} />
      </div>
      {onSearchClick && <SearchTrigger onClick={onSearchClick} />}
      <div className={`${styles.topBar__info} ${styles.topBar__user}`}>
        <div className={styles.topBar__text}>
          <div className={styles.username}>
            {`${tokenData?.firstName} ${tokenData?.lastName}`}
          </div>
          <div className={styles.accountName} style={{ gridArea: 'email' }}>
            {tokenData?.accountName}
          </div>
          <div className={styles.avatar} style={{ gridArea: 'avatar' }}>
            <ContextMenu
              items={[
                {
                  display: 'Switch Account',
                  value: 'switch',
                  action: () => {
                    nav(RouteList.SWITCHACCOUNT.link);
                  },
                },
                {
                  display: 'Logout',
                  value: 'logout',
                  action: () => {
                    dispatch(clearToken());
                  },
                },
              ]}
            >
              <div className={styles.menuLayout}>
                <Avvvatars
                  value={`${tokenData?.firstName?.[0]}${tokenData?.lastName?.[0]}`}
                />
                <ChevronDownIcon height={24} />
              </div>
            </ContextMenu>
          </div>
        </div>
        <div className={styles.topBar__avatar}>
          <i className="fas fa-chevron-down"></i>
        </div>
      </div>
    </div>
  );
};

export default TopBar;
